import FaLocale from 'element-ui/lib/locale/lang/fa'
export const messages = {
  fa: {
    ...FaLocale,
    publish_date: 'تاریخ انتشار',
    add_media: 'افزودن تصویر/فیلم',
    publishing_account_quota: 'تعداد اتصال حساب کاربری',
    publishing_post_quota: 'تعداد انتشار پست',
    ai_assistant_quota: 'دستیار AI',
    vibe_analysis_quota: 'تعداد اینباکس تحلیل احساس',
    of: 'از',
    inboxes: 'اینباکس‌ها',
    status: 'وضعیت',
    initialized: 'مقداردهی شده',
    initializing: 'در حال مقدار دهی',
    initilize_pending: 'مقداردهی نشده',
    total_mentions: 'مجموع منشن‌های دریافتی',
    main_phrase: 'کلمات کلیدی اصلی',
    required_phrases: 'کلمات کلیدی الزامی',
    excluded_phrases: 'کلمات کلیدی مستثنی',
    keywords: 'کلمات کلیدی',
    reports: 'وضعیت گزارش‌ها',
    report_types: 'نوع گزارش',
    report_members: 'دریافت‌کنندگان گزارش',
    daily_report: 'گزارش روزانه',
    monthly_report: 'گزارش هفتگی',
    weekly_report: 'گزارش ماهانه',
    exact_match: 'انطباق دقیق',
    pipes: 'اتصال محتوا',
    message: 'سلام',
    username: 'نام کاربری',
    password: 'کلمه عبور',
    field_required: 'این فیلد الزامی است.',
    invalid_grant: 'نام کاربری یا کلمه عبور اشتباه است.',
    server_error: 'خطای داخلی سرور',
    sign_in: 'ورود',
    sign_out: 'خروج',
    operator_panel: 'پنل اپراتور',
    roles: 'نقش‌ها',
    plans: 'بسته‌های عضویت',
    plan: 'بسته عضویت',
    teams: 'تیم‌ها',
    admin: 'مدیر',
    owner: 'مالک',
    regular: 'عادی',
    guest: 'مهمان',
    role: 'نقش',
    add: 'افزودن',
    remove: 'حذف',
    ok: 'ادامه',
    cancel: 'لغو',
    close: 'بستن',
    edit: 'ویرایش',
    name: 'نام',
    email: 'ایمیل',
    mobile: 'موبایل',
    user: 'کاربر',
    users: 'کاربران',
    tools: 'ابزار',
    submit: 'ثبت',
    copy_trace_token: 'لینک کپی شد',
    copy_the_trace_token: 'کپی کردن لینک',
    copy: 'کپی',
    customers: 'مشخصات کامل',
    user_panel: 'پنل کاربری',
    sign_in_to_user_panel: 'ورود به پنل کاربری',
    confirmation_status: 'وضعیت حساب کاربری',
    pending: 'تایید نشده',
    confirmed: 'تایید شده',
    change_access: 'تغییر دسترسی',
    enter_search_phrase: 'جستجو ...',
    is_cancelled: '{operation} لغو شد.',
    is_successful: '{operation} موفقیت آمیز بود.',
    basic_info: 'مشخصات پایه',
    edit_user: 'ویرایش کاربر',
    add_user: 'افزودن کاربر',
    confirm_role_access_update: 'آیا از {type} دسترسی نقش {role} به {operationID} مطمئنید؟',
    password_hint: 'حداقل هشت کاراکتر و شامل یک حرف و یک عدد',
    password_validator: 'کلمه عبور باید دارای حداقل هشت کاراکتر و شامل یک حرف و یک عدد باشد.',
    url_validator: 'لطفا یک آدرس معتبر را وارد کنید.',
    dashboard: 'داشبورد',
    one_week: 'یک هفته',
    one_month: 'یک ماه',
    three_months: 'سه ماه',
    plan_expiration: 'مهلت بسته عضویت',
    plan_remaining: 'مدت باقیمانده بسته عضویت',
    main: 'اصلی',
    required: 'الزامی',
    excluded: 'مستثنی',
    team_name: 'نام تیم',
    email_validation: 'لطفا یک آدرس ایمیل معتبر را وارد کنید.',
    limitations: 'محدودیت‌ها',
    features: 'خصوصیات',
    inbox_initialization_delay: 'مدت زمان مقداردهی اولیه اینباکس',
    inbox_update_interval: 'بازه به روز رسانی',
    mention_longevity: 'میزان دسترسی به آرشیو',
    mention_quota: 'تعداد محتوا',
    keyword_quota: 'تعداد کلمه کلیدی',
    ordered_source_quota: 'تعداد منبع درخواستی',
    team_capacity: 'تعداد هم تیمی',
    last_7_days: 'هفت روز گذشته',
    last_48_hours: 'دو روز گذشته',
    last_24_hours: 'روز گذشته',
    rial: 'ریال',
    toman: 'تومان',
    year: 'ماه',
    month: 'سال',
    day: 'روز',
    hours: 'ساعت',
    minutes: 'دقیقه',
    seconds: 'ثانیه',
    edit_plan: 'ویرایش بسته عضویت',
    add_plan: 'افزودن بسته عضویت',
    troubleshooting: 'عیب‌یابی',
    source: 'منبع',
    content: 'محتوا',
    source_url: 'آدرس منبع',
    source_troubleshooting: 'بررسی منبع',
    content_url: 'آدرس محتوا',
    content_troubleshooting: 'بررسی محتوا',
    search: 'جستجو',
    advanced_search: 'جستجوی پیشرفته',
    resource_not_found: '{resource} موجود نیست.',
    link: 'لینک',
    plan_assignment: 'تخصیص بسته عضویت',
    plan_assignment_to: 'تخصیص بسته عضویت به {name}',
    edit_team: 'ویرایش تیم',
    select: 'انتخاب',
    please_wait: 'لطفا صبر کنید...',
    search_in: 'جستجو در {param}',
    clear_search: 'نمایش همه',
    insert_email_or_mobile: 'ایمیل یا موبایل خود را وارد کنید.',
    insert_verification_code: 'ورود کد فعالسازی',
    insert_new_password: 'ورود مشخصات',
    next_step: 'مرحله بعد',
    prev_step: 'مرحله قبل',
    please_enter_verification_code: 'کد فعال‌سازی را وارد کنید.',
    verification_code: 'کد فعال‌سازی',
    login_to_newsbox: 'ورود به نیوزباکس',
    insert_email: 'ورود ایمیل',
    confirm_password: 'تایید کلمه عبور',
    registration_successful: 'حساب کاربری با موفقیت ساخته شد.',
    please_insert_password_confirmation: 'تکرار کلمه عبور را وارد کنید.',
    passwords_do_not_match: 'کلمه‌های عبور با هم تطابق ندارند.',
    insert_emailed_verification_code: 'کد فعال‌سازی‌ که برایتان ارسال شده‌ است را وارد کنید.',
    media: 'حوزه‌های جستجو',
    insert_integer: 'یک مقدار عددی را وارد کنید.',
    total_mentions_stats: 'آمار محتوای دریافتی',
    update: 'به‌روزرسانی',
    email_already_exists: 'با این ایمیل قبلا درخواست ثبت نام داده شده است. کد فعال سازی دوباره به ایمیل ارسال شد.',
    can_not_send_verification_code_under_n_minutes: 'ارسال مجدد کد فعالسازی کمتر از یک دقیقه امکان‌پذیر نیست',
    plan_name: 'نام بسته عضویت',
    plan_keyword_counter_gte: 'کلمات کلیدی استفاده شده از',
    plan_keyword_counter_lte: 'کلمات کلیدی استفاده شده تا',
    plan_mention_counter_gte: 'محتوای استفاده شده از',
    plan_mention_counter_lte: 'محتوای استفاده شده تا',
    plan_expiry_gte: 'تاریخ پایان بسته عضویت از',
    plan_expiry_lte: 'تاریخ پایان بسته عضویت تا',
    team_info: 'مشخصات تیم',
    members: 'اعضا',
    inbox: 'اینباکس',
    total_sum: 'جمع کل',
    team: 'تیم',
    inbox_status: 'وضعیت اینباکس',
    inbox_info: 'اطلاعات اینباکس',
    no_results: 'نتیجه‌ای یافت نشد.',
    inbox_name: 'نام اینباکس',
    reset: 'از نو',
    today: 'امروز',
    yesterday: 'دیروز',
    total: 'کل',
    stats: 'آمار',
    trace_tokens: 'لینک‌های دعوت',
    add_trace_token: 'افزودن لینک دعوت',
    edit_trace_token: 'ویرایش لینک دعوت',
    campaign_name: 'نام کمپین',
    expiry: 'تاریخ انقضا',
    report: 'گزارش',
    active: 'فعال',
    deactive: 'غیر فعال',
    token_expiration: 'مهلت اعتبار توکن',
    submit_trace_token: 'ثبت لینک دعوت',
    trace_token: 'لینک',
    price_30_days: 'قیمت ۳۰ روز',
    price_90_days: 'قیمت ۹۰ روز',
    price_180_days: 'قیمت ۱۸۰ روز',
    price_360_days: 'قیمت ۳۶۰ روز',
    unsupported_type: 'فرمت فایل انتخاب شده صحیح نمی باشد',
    maximum_size_1mb: 'حجم فایل انتخاب شده بیش از ۱ مگابایت است',
    multimedia: 'چندرسانه ای',
    plan_feature: {
      description: 'توضیحات',
      export_types: 'خروجی',
      report_types: 'گزارش آماری',
      outlets: 'اتصال محتوا',
      customer_support_types: 'پشتیبانی',
      is_external_api_valid: 'API',
      is_journal_valid: 'دسترسی به نشریات',
      is_bulletin_valid: 'دسترسی به بولتن خودکار',
      ai_assistant_quota: 'دستیار AI',
      is_retweet_valid: 'فعال سازی دریافت ریتوییت',
      is_addon_valid: 'دسترسی به بسته افزایشی',
      phone: 'تلفن',
      chat: 'چت',
      mail: 'ایمیل',
      show_in_panel: 'نمایش در پنل',
      do_not_show_in_panel: 'عدم نمایش در پنل',
      sms: 'پیامک',
      slack: 'اسلک',
      app_push: 'موبایل',
      web_push: 'وب',
      telegram: 'تلگرام',
      periodical: 'دوره ای',
      basic: 'پایه',
      inbox_initialization_delay: 'مدت زمان مقداردهی اولیه اینباکس',
      inbox_update_interval: 'بازه به روز رسانی',
      media: 'حوزه‌های جستجو',
      email: 'ایمیل',
      special_offer: 'پیشنهاد ویژه',
      special_plan: 'بسته پیشنهادی',
      normal_plan: 'بسته معمولی',
      bale: 'بله',
      custom_inbox_init: 'امکان ساخت اینباکس سفارشی',
      custom_inbox_init_true: 'امکان ساخت اینباکس سفارشی دارد',
      custom_inbox_init_false: 'امکان ساخت اینباکس سفارشی ندارد'
    },
    addons: 'بسته‌های افزایشی',
    addon: 'بسته افزایشی',
    add_addon: 'افزودن بسته افزایشی',
    edit_addon: 'ویرایش بسته افزایشی',
    price: 'قیمت',
    addon_assignment: 'تخصیص بسته افزایشی',
    addon_assignment_to: 'تخصیص بسته افزایشی به {name}',
    announcements: 'اطلاعیه‌ها',
    announcement_type: 'نوع',
    title: 'عنوان',
    text: 'متن',
    image_url: 'لینک عکس',
    button_link: 'لینک دکمه',
    button_description: 'عنوان دکمه',
    add_announcement: 'افزودن اطلاعیه',
    edit_announcement: 'ویرایش اطلاعیه',
    delete_announcement: 'اطلاعیه حذف شد.',
    diactive_announcement: 'اطلاعیه غیر فعال شد.',
    active_announcement: 'اطلاعیه فعال شد.',
    delete: 'حذف',
    discounts: 'کد‌های تخفیف',
    add_discount: 'افزودن کد تخفیف',
    percentage: 'درصد',
    code: 'کد',
    usage_limit: 'محدودیت تعداد استفاده',
    usage_limit_per_user: 'محدودیت تعداد استفاده به ازای هر کاربر',
    expiration_date: 'تاریخ انقضا',
    description: 'توضیحات',
    deactivation: 'غیر فعال کردن',
    discount_expiration: 'مهلت اعتبار کد تخفیف (روز)',
    diactive_discount: 'کد تخفیف غیر فعال شد.',
    banned: 'بن شده',
    operators: 'اپراتور‌ها',
    edit_operator: 'ویرایش اپراتور',
    add_operator: 'افزودن اپراتور',
    ban: 'بن کردن',
    templates: 'تمپلیت‌ها',
    edit_template: 'ویرایش تمپلیت',
    language: 'زبان',
    flavor: 'نوع',
    activation: 'فعال کردن',
    financial_support: 'مالی',
    marketing_manager: 'مدیر بازاریابی',
    account_manager: 'مدیریت مشترکان',
    pr_officer: 'روابط عمومی',
    support: 'پشتیبانی',
    zeus: 'مدیر',
    user_account_mod: 'مدیر اکانت',
    add_content: 'افزودن محتوا',
    add_source: 'افزودن منبع',
    resources: 'منابع',
    delete_resource: 'حذف منبع',
    delete_resource_confirm: 'آیا از حذف منبع اطمینان دارید؟',
    delete_keyword: 'حذف کلمه کلیدی',
    delete_keyword_confirm: 'آیا از حذف کلمه کلیدی اطمینان دارید؟',
    verified: 'تایید',
    priority: 'اولویت',
    true: 'دارد',
    false: 'ندارد',
    sort: 'مرتب‌سازی',
    'priority:asc': 'اولویت، صعودی',
    'priority:desc': 'اولویت، نزولی',
    'created_at:asc': 'تاریخ ساخت، صعودی',
    'created_at:desc': 'تاریخ ساخت، نزولی',
    all: 'همه',
    verifiedKeyword: 'تایید شده',
    unverifiedKeyword: 'تایید نشده',
    select_start_date: 'انتخاب تاریخ شروع',
    select_end_date: 'انتخاب تاریخ پایان',
    created_at: 'تاریخ ساخت',
    updated_at: 'تاریخ به‌روزرسانی'
  }
}
